import { render, staticRenderFns } from "./ServiceLightStep4.vue?vue&type=template&id=38b07aca"
import script from "./ServiceLightStep4.vue?vue&type=script&scoped=true&lang=js"
export * from "./ServiceLightStep4.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./ServiceLightStep4.vue?vue&type=style&index=0&id=38b07aca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports